export default __webpack_public_path__ + "static/media/about-1.087c66c3.png";